/*
 * Copyright (C) 2021 Corsair M360, Inc - All Rights Reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

import globalMixins from "@/mixins/globalMixins";

export default {
	name: 'fieldsMixins',
	
	mixins: [globalMixins],
	
	data() {
		return {
			fieldsAcl: {
				tenant: {
					create: {},
					update: {
						config: true
					},
					list: {
						config: false,
						security: false,
					}
				}
			}
		}
	},
	
	components: {},
	
	computed: {},
	
	methods: {
		
		tenantListAccess() {
			let route = '/environments/:env/:type/tenants';
			let method = 'get';
			
			this.fieldsAcl.tenant.list = {
				config: this.canAccessField({
					route: route,
					method: method,
					field: 'config'
				}),
				security: this.canAccessField({
					route: route,
					method: method,
					field: 'security'
				}),
			};
			return this.fieldsAcl.tenant.list;
		},
		
		tenantCreateAccess() {
			// let route = '/environments/:env/tenants';
			// let method = 'put';
			
			this.fieldsAcl.tenant.create = {};
			return this.fieldsAcl.tenant.create;
			
		},
		
		tenantUpdateAccess() {
			let route = '/environments/:env/tenants/:id';
			let method = 'patch';
			
			this.fieldsAcl.tenant.update = {
				config: this.canAccessField({
					route: route,
					method: method,
					field: 'config'
				}),
			};
			
			return this.fieldsAcl.tenant.update;
		}
	}
}
